import React, { Component } from "react";
import axios from "axios";
import tt from "@tomtom-international/web-sdk-maps";
import tt2 from "@tomtom-international/web-sdk-services";


const mapStyle = {
  background: "rgba(35, 55, 75, 0.9)",
  color: "#fff",
  padding: " 6px 12px",
  zIndex: "1",
  position: "absolute",
  top: "0",
  left: "0",
  margin: "12px",
  borderRadius: "4px",
};

let map = {};
let markers = [];

const initialState = {
  apiKey: 'zPAt5zqpe3CuAIMnWdFKYnQJEw7LYTeu',
  URL:
    "https://api.tomtom.com/routing/waypointoptimization/1/best?key=" +
    'zPAt5zqpe3CuAIMnWdFKYnQJEw7LYTeu',
};

class TryMap extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  // Create map
  async componentDidMount() {
    const { waypoints, centerLocation, showRoute } = this.props;
    //   const waypoints = [
    //   { lng: -99.1332, lat: 19.4326 },   // CDMX
    //   { lng: -100.3161, lat: 25.6866 },  // Monterrey
    //   { lng: -103.3496, lat: 20.6597 },  // Guadalajara
    // ];

    await this.AllForMap(waypoints, centerLocation, showRoute);
  }

  async shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.waypoints !== this.props.waypoints /*|| nextState.waypoints.length === this.props.waypoints.length */ || nextProps.centerLocation !== this.props.centerLocation) {
      await this.AllForMap(nextProps.waypoints, nextProps.centerLocation, nextProps.showRoute);
      return true;
    }
  }

  SendInfoToFather = (info = null) => {
    const { sendInfoToFather } = this.props
    sendInfoToFather(info);
  }

  SendInfoToFather = (info = null) => {
    const { sendInfoToFather } = this.props
    sendInfoToFather(info);
  }

   AllForMap = async (waypoints, centerLocationAux = null, showRoute = true) => {
    const { apiKey, URL } = this.state;
    // we have a center location
    let band = false;
    let centerLocation = centerLocationAux || (waypoints && waypoints[0]) || { lng: -98.7854921, lat: 20.0285691 };
    // let centerLocation = { lng: -98.7854921, lat: 20.0285691};
    try {
      map = await tt.map({
        key: apiKey,
        container: "mymap",
        center: centerLocation,
        bearing: 0,
        maxZoom: 21,
        minZoom: 1,
        pitch: 60,
        zoom: 14,
      });
      band = true;
    } catch (error) {  }

    if (waypoints && waypoints.length >= 2 && band === true) {
      map.on("click", function (event) { });
      // this.createMarker("controlShiftR.jpg", waypoints[0], "orange", "Origin");

      waypoints.forEach(function (location, index) {
        markers.push(new tt.Marker().setLngLat(location).addTo(map));
        if (index !== 0) {
        }
      });
      if (!showRoute) return;
      axios
        .post(URL, {
          waypoints: waypoints.map(function (element) {
            return {
              point: {
                latitude: element.lat,
                longitude: element.lng,
              },
            };
          }),
        })
        .then(async function (response) {

          let solution = response.data.optimizedOrder;
          let locations = solution.map((order, index) => {
            let popup = new tt.Popup({ offset: 50 }).setText(
              "Destination #" + index
            );

            markers[order].setPopup(popup);
            return waypoints[order];
          });

          await tt2.services.calculateRoute({ key: apiKey, locations: locations })
            .then((response) => {
              this.SendInfoToFather(response); // Ahora 'this' se refiere correctamente al componente.
              var features = response.toGeoJson().features;
              console.log("features", features);
              features.forEach((feature, index) => {
                map.addLayer({
                  id: "route" + index,
                  type: "line",
                  source: {
                    type: "geojson",
                    data: feature,
                  },
                  paint: {
                    "line-color": "blue",
                    "line-opacity": 0.7,
                    "line-width": 10,
                    "line-dasharray": [1, 0, 1, 0],
                  },
                  layout: {
                    "line-cap": "round",
                    "line-join": "round",
                  },
                });
              });
            });
        })
        .catch((error) => {
          console.log(`R2D2>> error`, error);
        });
    } else if (waypoints && waypoints.length === 1 && band === true) {
      const point = waypoints?.[0] || null;
      if (point) {
        markers.push(new tt.Marker().setLngLat(point).addTo(map));
      }


    }

    this.resizeMap()
  };

  resizeMap() {
    try { map.resize(); } catch (err) { }
  }

  createRoute = (options) => {
    tt2.services.calculateRoute(options).then(function (response) {
      var features = response.toGeoJson().features;
      console.log(features);
      features.forEach(function (feature, index) {
        map.addLayer({
          id: "route" + index,
          type: "line",
          source: {
            type: "geojson",
            data: feature,
          },
          paint: {
            "line-color": "blue",
            "line-opacity": 0.7,
            "line-width": 10,
            "line-dasharray": [1, 0, 1, 0],
          },
          layout: {
            "line-cap": "round",
            "line-join": "round",
          },
        });
      });
    });
  };

  createMarker(icon, position, color, popupText) {
    var markerElement = document.createElement("div");
    markerElement.className = "marker";

    var markerContentElement = document.createElement("div");
    markerContentElement.className = "marker-content";
    markerContentElement.style.backgroundColor = color;
    markerElement.appendChild(markerContentElement);

    var iconElement = document.createElement("div");
    iconElement.className = "marker-icon";
    iconElement.style.backgroundImage = "url(" + icon + ")";
    markerContentElement.appendChild(iconElement);

    var popup = new tt.Popup({ offset: 50 }).setText(popupText);
    // add marker to map
    markers.push(
      new tt.Marker({ element: markerElement, anchor: "bottom" })
        .setLngLat(position)
        .setPopup(popup)
        .addTo(map)
    );
  }

  render() {
    const { compHeader = null } = this.props
    return (
      <div>
        {/* <div style={mapStyle}>
        Longitude: {configPoint && configPoint.lng} | Latitude:{" "}
          {configPoint && configPoint.lat} | Zoom:{" "}
          {configPoint && configPoint.zoom}
          <button type="button" onClick={() => this.DrawRoute()} class="btn btn-primary">dibujar ruta</button>
                    <button type="button" onClick={() => this.RequestAPI()} class="btn btn-primary">PETICION API </button>
        </div> */}
        {compHeader !== null &&
          <div style={mapStyle}>
            {compHeader}
          </div>
        }

        <div id="mymap" style={{ height: "800px" }} />
      </div >
    );
  }
}

export default TryMap;
